/* eslint-disable react-hooks/rules-of-hooks */
import { gql, useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import React from "react";
import { useExpandedStoreWithComponentState } from "../../trees-virtual/hooks/useExpandedStore.js";
import {
  defaultAllOpenedValue,
  useExpandedStoreWithLocalStorage,
} from "../../trees-virtual/hooks/useExpandedStore.js";
import {
  DecisionsInBulkProcess,
  DecisionsInBulkProcessRef,
} from "../doc-items/modals/DecisionsInBulkProcess.js";
import { useRequirementDecisionsInBulkProcessLazyQuery } from "./RequirementDecisionsInBulkProcess.generated.js";

interface Props extends Omit<
  React.ComponentProps<typeof DecisionsInBulkProcess>,
  | "projectId"
  | "docType"
  | "docId"
  | "allDocItems"
  | "fetchItems"
  | "isLoading"
  | "expandedStore"
> {
  projectId: string;
  requirementId: string;
}

export const RequirementDecisionsInBulkProcess = React.forwardRef(
  _RequirementDecisionsInBulkProcess
);

function _RequirementDecisionsInBulkProcess(
  { projectId, requirementId, ...rest }: Props,
  ref: React.ForwardedRef<DecisionsInBulkProcessRef>
) {
  const expandedStore = useExpandedStoreWithComponentState();

  const client = useApolloClient();
  const [fetchData, query] = useRequirementDecisionsInBulkProcessLazyQuery({
    client,
    variables: {
      projectId,
      requirementId,
    },
    fetchPolicy: "no-cache",
    nextFetchPolicy: "no-cache",
  });

  const fetchItems = async () => {
    const result = await fetchData();
    return getDataOrNull(result.data?.requirement)?.requirement?.items ?? [];
  };

  return (
    <DecisionsInBulkProcess
      ref={ref}
      projectId={projectId}
      docType="REQUIREMENT"
      docId={requirementId}
      fetchItems={fetchItems}
      isLoading={query.loading}
      expandedStore={expandedStore}
      {...rest}
    />
  );
}
